<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId"
    [verifyRequiredValidator]="verifyRequiredValidator" [primaryButtonLabel]="primaryButtonLabel"
    (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy" [modalHelpIndex]="modalHelpIndex"
    [(isBusyMessage)]="isBusyMessage" [modalClass]="modalClass">
    <div id="topSection">
        <div class="left-section" data-automation-id="new-data-set-connector-table-container">
            <res-generic-grid id="connectorGrid" [gridName]="gridName" [automationId]="gridAutomationId"
                [updateStatusType]="updateStatusType" [(isBusy)]="isBusyGrid" [(isBusyMessage)]="isGridBusyMessage"
                [columnDefs]="columnDefs" [requestInfo]="requestInfo" [pagerVisible]="false"
                [onSelectionChanged]="connectorOnSelectionChanged" [rowSelection]="connectorSelection"
                [gridContext]="connectorsGridContext" [responseCallback]="responseCallback">
            </res-generic-grid>
        </div>

        <div class="right-panel">
            <div class="right-section">
                <res-new-data-set-load-file-menu
                [modalAutomationId]="modalAutomationId"
                [isSmfDataSetModal]="modalData?.shortMessageFormat">
                </res-new-data-set-load-file-menu>
            </div>
            @if (hasAddToProjectPermissions) {
                <div class="right-footer modal-row path-area" [hidden]="isLoadFile">
                    <div class="modal-row-column-auto">
                        <res-custom-checkbox
                            [automationId]="modalAutomationId + '-add-to-project-data'"
                            [(ngModel)]="addToProjectData"
                            content="Add to Project Data"
                            [isDisabled]="menuComponent.getIndexLevelSetting().indexLevelType === IndexLevel.DO_NOT_INDEX || menuComponent.getIndexLevelSetting().indexLevelType === IndexLevel.SYSTEM_METADATA || menuComponent.getIndexLevelSetting().indexLevelType === IndexLevel.FILE_METADATA">
                        </res-custom-checkbox>
                    </div>
                </div>
            }
        </div>
    </div>

    <res-resizer anchor="up" ellipsisExpander="true" resizingElementId="topSection" secondElementId="bottomSection"
        [collapsible]="false" [minSize]="30" [maxSize]="70" [initSize]="50" [usePercentages]="true"></res-resizer>
    <div id="bottomSection" [hidden]="isConnectorSelected">
        <span class="noTreeInfo">
            <div class="hint-popover">
                <i class="fa fa-arrow-up"></i>Please select a connector
            </div>
        </span>
    </div>
    <div id="bottomSection" [hidden]="!isConnectorSelected">
        <div class="heading-section">
            <div class="text-styles">
                <div class="data-area-text">
                    {{isGoogleConnectorSelected ? 'Accounts and Services' : 'Data Area'}}
                </div>
                <div class="showHide-grids-text">
                    <div class="checkbox-area" *ngIf="!isGoogleConnectorSelected">
                        <li class="dropdown" dropdown>
                            <div dropdownToggle role="button" class="refresh-reset-toggle" [attr.data-automation-id]="modalAutomationId + '-refresh-and-reset-button'">
                                <i class="fa fa-retweet color-blue-01"></i>
                                <span>Refresh & Reset</span>
                                <i class="fa fa-caret-down color-blue-01"></i>
                            </div>
                            <ul *dropdownMenu class="dropdown-menu" role="menu">
                                <li (click)="refreshCustodianMediaIdGrids()" class="custom-dropdown-option"
                                    [attr.data-automation-id]="modalAutomationId + '-custodians-and-mediaids-only-button'">
                                    <i class="fa fa-retweet color-blue-01"></i><span>Custodians and MediaIDs only</span>
                                </li>
                                <li (click)="refreshAll()" class="custom-dropdown-option"
                                    [attr.data-automation-id]="modalAutomationId + '-folders-custodians-and-mediaids-button'">
                                    <i class="fa fa-retweet color-blue-01"></i><span>Folders, Custodians, and MediaIDs</span>
                                </li>
                            </ul>
                        </li>
                    </div>
                    <div class="checkbox-area" *ngIf="isGoogleConnectorSelected">
                        <button type="button" class="google-reset-custodians-and-mediaid-button"
                            (click)="resetCustodiansMediaIDsForGoogle()"
                            [attr.data-automation-id]="modalAutomationId + 'reset-custodians-and-mediaids-button'">
                            <i class="fa fa-retweet color-blue-01"></i>
                            Reset Custodians and MediaIDs
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="tree-grids-section">
            <div class="tree-wrapper" id="folderSection">
                <div class="filter-class" *ngIf="!isGoogleConnectorSelected">
                    <res-filter  #resFilterComponent [filterInputAutoId]="modalAutomationId" [clearButtonDataAutoId]="modalAutomationId" [maxChars]=32
                        [placeholder]='"Filter..."' [callback]="filterData.bind(this)" [autofocusInput]="inputAutoFocused"></res-filter>
                </div>
                <div class="tree-section" [resBusySpinner]="isPathsBusy" [message]="isBusyMessage">
                    <res-generic-tree [automationId]="modalAutomationId + '-tree'" [isMultiSelect]="isGoogleConnectorSelected"
                        [loadNodeDataCallback]="loadNodeDataCallback"
                        [checkboxSelectionChangedCallback]="checkboxSelectionChangedCallback"
                        [nodeAlternativeIconCallback]="nodeAlternativeIconCallback"></res-generic-tree>
                </div>
            </div>
            <res-resizer #treeLeftResizer anchor="left" [hidden]='!isConnectorSelected' ellipsisExpander="true"
                resizingElementId="folderSection" secondElementId="gridsSection" [initSize]="35" [minSize]="20"
                [maxSize]="50" [usePercentages]="true"></res-resizer>
            <div class="grids-section" id="gridsSection">
                <div id="custodianGridSection">
                    <res-generic-grid [hidden]='isGoogleConnectorSelected' #custodianGrid [automationId]="modalAutomationId + '-custodian-grid'" [hasCustomCellTemplates]="true"
                        [helpIndex]="modalHelpIndex" [updateStatusType]="updateStatusType" [pagerVisible]="false" [rowHeight]="50"
                         [(isBusy)]="custodiansAndMediaIDs.isBusy.custodian" [(isBusyMessage)]="isBusyMessage" [columnDefs]="custodianColumnDefs"
                        [gridContext]="gridContext(true)" [suppressRowTransform]="true" [maxHeightToIncreaseViewport]="140">
                    </res-generic-grid>
                    <res-generic-grid [hidden]='!isGoogleConnectorSelected' #googleCustodianGrid [automationId]="modalAutomationId + '-custodian-grid'" [hasCustomCellTemplates]="true"
                        [helpIndex]="modalHelpIndex" [updateStatusType]="updateStatusType" [pagerVisible]="false" [rowHeight]="50" [rowSelection]="'multipleCheckboxWithRowClickSelection'"
                        [(isBusy)]="custodiansAndMediaIDs.isBusy.custodian" [(isBusyMessage)]="isBusyMessage" [columnDefs]="googleCustodianColumnDefs" [onSelectionChanged]="custodianOnSelectionChanged"
                        [gridContext]="gridContext(true)" [suppressRowTransform]="true" [maxHeightToIncreaseViewport]="140">
                    </res-generic-grid>
                </div>
                <res-resizer anchor="left" ellipsisExpander="true" *ngIf='isConnectorSelected'
                    resizingElementId="custodianGridSection" secondElementId="mediaIDGridSection" [collapsible]="false"
                    [initSize]="50" [minSize]="30" [maxSize]="70" [usePercentages]="true"></res-resizer>
                <div id="mediaIDGridSection">
                    <res-generic-grid #mediaIdGrid [automationId]="modalAutomationId + '-mediaId-grid'" [hasCustomCellTemplates]="true"
                     [helpIndex]="modalHelpIndex" [updateStatusType]="updateStatusType" [pagerVisible]="false" [rowHeight]="50"
                        [(isBusy)]="custodiansAndMediaIDs.isBusy.mediaId" [(isBusyMessage)]="isBusyMessage" [columnDefs]="mediaIDColumnDefs"
                         [gridContext]="gridContext(false)" [suppressRowTransform]="true" [maxHeightToIncreaseViewport]="140">
                    </res-generic-grid>
                </div>
            </div>
        </div>
    </div>
</res-base-modal>